<template>
  <v-container class="noMargin">
    <v-layout row wrap>
      <v-flex lg12>
        <div class="pageTitle">
          <h2>TENDER REPORTS</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque a nulla mauris. Vestibulum augue enim, aliquam eget mi sit amet, mattis tempus risus. Vivamus blandit pretium lorem eu placerat. Aenean tincidunt lobortis massa, non viverra nibh volutpat ac. Maecenas sed bibendum neque. Cras et nisl tortor.</p>
        </div>
        <!--<v-btn @click.prevent="fncShowFilter" class="elevation-5	" color="info">FILTER / GENERATE REPORT</v-btn>-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'TenderHeader',
    data() {
      return {

      }
    },
  }
</script>

<style scoped>
  /*@import '../../shared/assets/css/shared.css'*/
</style>